/*
 * File: d:\projects\AutoFiFront\public\BrandSvg\DS.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday March 10th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday March 10th 2023 5:05:38 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { SVGProps } from 'Content/SVG/SVGProps';

function DS(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <path d="M658.98,479.04c-4.48-13.45-6.41-26.27-6.41-37.8,0-10.25,2.56-21.78,6.41-33.31,8.33-21.14,25.62-45.48,51.89-73.03,8.33-8.97,42.92-43.56,60.86-60.86,.64-.64,1.28-1.28,1.92-2.56-17.94,14.09-105.7,92.25-124.28,137.73-4.48,10.89-7.05,21.14-7.05,32.03,0,11.53,1.92,23.7,6.41,35.23,21.14,60.22,99.3,130.04,112.75,142.86-36.51-35.87-86.48-91.61-102.5-140.29h0Z"/>
            <path d="M671.15,604.6c-21.14-60.22-101.22-131.97-114.03-143.5,35.23,34.59,87.12,90.97,103.14,140.94,4.48,13.45,6.41,26.27,6.41,37.8,0,10.25-2.56,21.78-6.41,33.31-8.33,21.14-25.62,45.48-51.89,73.03-8.97,9.61-48.05,48.05-60.86,60.86-.64,.64-1.28,1.28-1.92,2.56,17.94-14.73,105.06-92.25,124.28-137.73,4.48-10.89,7.05-21.14,7.05-32.03,.64-11.53-1.28-23.06-5.77-35.23Z"/>
            <path d="M774.29,628.94c-16.66-16.02-92.89-88.4-113.39-150.54-4.48-12.81-6.41-24.98-6.41-37.16,0-10.89,2.56-21.14,6.41-32.03,9.61-24.34,30.11-50.61,51.25-72.39,8.97-9.61,48.05-48.05,60.86-61.5,3.2-3.2,5.12-7.05,5.77-10.89s1.28-7.69,1.28-10.25v-7.05l-232.54,180.01c-2.56,1.92-6.41,5.12-7.69,10.25-1.28-4.48-5.12-8.33-7.69-10.25l-232.54-180.65v388.85l232.54-180.65c2.56-1.92,6.41-5.12,7.69-10.25,1.28,3.84,3.84,7.05,5.12,7.69,16.66,16.02,93.53,88.4,114.03,150.54,4.48,12.81,6.41,24.98,6.41,37.16,0,10.89-2.56,21.14-6.41,32.03-9.61,24.34-30.11,50.61-51.25,72.39-8.97,9.61-48.05,48.69-60.86,61.5-2.56,2.56-5.12,7.05-5.77,10.89-.64,3.2-1.28,6.41-1.28,10.25v7.05l232.54-180.65c3.2-2.56,8.33-7.05,8.33-13.45-.64-5.77-5.12-9.61-6.41-10.89h0Z"/>
        </svg>
    );
}

export default DS;
